import {  useState } from 'react';
import { IconMoreVerticalDots, FileTracking } from '../../../../components/buttons/IconButtons';
import DropDownMenuItem from '../../../../components/DropDown/DropDownMenuItem';
import DropDownMenuProfile from '../../../../components/DropDown/DropDownMenuProfile';
import TableFunction from '../../../../components/table/TableFunction';
import { useTranslation } from 'react-i18next';
import { SEARCH_MODEL } from '../../../../components/table/Model/TableModel';

import { useDispatch } from 'react-redux';
import { GetEquipmentList } from '../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import {VIEW_TYPE} from "../../../../enums/ViewType";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EquipmentMaterialSectionApp = ({ contractorId }) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // Controls visibility of the documentation modal
    const [selected, setSelected] = useState(null); // Stores currently selected vehicle for documentation
    const [selectedList, setSelectedList] = useState([]); // Stores selected rows from the table
    const [searchElement, setSearchElement] = useState(''); // Search input text
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false); // Flag to use simple search mode
    const searchId = 'txt_ema_search_equipment_material'; // Search input DOM ID
    const [showMarkAsReadModal, setShowMarkAsReadModal] = useState(false);
    const option = ''; // Option identifier passed to API actions
    const [results, setResults] = useState({
        content: [],
        totalElement:0
    });
    const [markAsCompleted, setMarkAsCompleted] = useState(false);
    const { t } = useTranslation();

    // Render dropdown menu for each vehicle row
    const getActionsButtons = (item, index) => {
        return (
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`}
                icon={<IconMoreVerticalDots />}
            >
                <DropDownMenuItem
                    id={`btn_ems_download_${item.id}`}
                    index={index}
                    handleClose={handleClose}
                    name={t('tracking')}
                    icon={<FileTracking />}
                    click={() => {
                        setSelected(item);
                        setShowModal(true);
                    }}
                />
            </DropDownMenuProfile>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, { searchElement }) => {
        const bodyConfig = {
            page,
            size: rowsPerPage,
            userId: contractorId,
            key: searchElement
        };
        const body = SEARCH_MODEL.setObject(bodyConfig);
        dispatch(GetEquipmentList(body)).then(
            ({
                 payload: {
                     data: { data, success}
                 }
             }) => {
                if (success) {
                    setResults(data);
                }
            }
        );
    };

    // Table logic: pagination, selection, menu state
    const { handleMenuToggle, handleClose, openMenu, page, rowsPerPage, pagination } = TableFunction({
        selectedList,
        setSelectedList,
        labelRowsPerPage: 'equipment_per_page',
        data: results,
        hasContainer: true,
        fixedPagination: false,
        view: VIEW_TYPE.GRID.name,
        searchElement, //New
        getData //New

    });

    return {
        t,
        selected,
        setSelected,
        searchId,
        setResults,
        results,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        option,
        page,
        rowsPerPage,
        simpleSearch,
        setSimpleSearch,
        showModal,
        setShowModal,
        showMarkAsReadModal,
        setShowMarkAsReadModal,
        pagination,
        getActionsButtons,
        dispatch,
        getData,
        markAsCompleted,
        setMarkAsCompleted
    };
};

export default EquipmentMaterialSectionApp;
